<template>
    <div v-show="isLoading" class="loading-overlay">
        <span class="loader" />
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { usePageLoadingStore } from '@shared-store'
import { storeToRefs } from 'pinia'

export default defineComponent({
    name: 'LoadingPage',
    setup() {
        // 取得載入狀態
        const { isLoading } = storeToRefs(usePageLoadingStore())


        return {
            isLoading,
        }
    },
})
</script>
<style scoped lang="scss">
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;

    .loader {
        width: 64px;
        height: 64px;
        border: 8px solid #fff;
        border-bottom-color: transparent;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
    }
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
